
import { common as frCommon } from './fr/common';
import { common as enCommon } from './en/common';

const resources = {
  fr: {
    common: frCommon,
  },
  en: {
    common: enCommon,
  },
};

export default resources;
